import React from 'react'

function Header() {
    return (
        <div >
            <p className="fw-bold fs-3 col-12 border-bottom">Where in the world? </p>
        </div>
    )
}

export default Header
